import { PageUrlSegment } from '../types';

export const getMainUrlSegment = (url: string): PageUrlSegment => {
  const numberOfSlashes: number = (url.match(/\//g) || []).length;
  let mainUrlSegment = '';
  if (url !== '/') {
    if (url.includes('select-card')) {
      return PageUrlSegment.SELECT_CARD;
    }
    if (url.includes('shopping-cart/home')) {
      return PageUrlSegment.SHOPPING_CART_HOME;
    }
    if (url.includes('gift_card/checkout/auto-redemption/success')) {
      return PageUrlSegment.GIFTCARD_AUTOREDEMPTION_SUCCESS;
    }
    if (url.includes('transfer/checkout/auto-redemption/success')) {
      return PageUrlSegment.TRANSFER_AUTOREDEMPTION_SUCCESS;
    }
    if (url.includes('redeem_cash/checkout/auto-redemption/success')) {
      return PageUrlSegment.REDEEMCASH_AUTOREDEMPTION_SUCCESS;
    }
    if (url.includes('redeem_cash/checkout/auto-redemption')) {
      return PageUrlSegment.REDEEMCASH_AUTOREDEMPTION;
    }
    if (url.includes('gift_card/checkout/auto-redemption')) {
      return PageUrlSegment.GIFTCARD_AUTOREDEMPTION;
    }
    if (url.includes('redeem_cash/checkout/enrollment')) {
      return PageUrlSegment.REDEEMCASH_ENROLLMENT;
    }
    if (url.includes('orders/manage-auto-redemptions')) {
      return PageUrlSegment.MANAGE_REDEMPTIONS;
    }
    if (url.includes('transfer/checkout') && url.includes('membership')) {
      return PageUrlSegment.TRANSFER_ADD_MEMBERSHIP;
    }
    if (url.includes('transfer/checkout/auto-redemption')) {
      return PageUrlSegment.TRANSFER_AUTOREDEMPTION;
    }
    if (url.includes('transfer/checkout')) {
      return PageUrlSegment.TRANSFER_LANDING;
    }
    if (url.includes('everyday_rewards/checkout/auto-redemption/success')) {
      return PageUrlSegment.EVERYDAY_SPEND_AUTOREDEMPTION_SUCCESS;
    }
    if (url.includes('everyday_rewards/checkout/auto-redemption')) {
      return PageUrlSegment.EVERYDAY_SPEND_AUTOREDEMPTION;
    }
    if (numberOfSlashes === 3) {
      mainUrlSegment = url.substring(0, url.lastIndexOf('/'));
    } else if (url.includes('?state')) {
      // This condition is to handle the scenarios where we have state
      // uri param is appended to the url after redirected from GH
      mainUrlSegment = '';
    } else if (url.includes('?')) {
      // This condition is to handle giftcard review page
      // where the url pattern is gift_card/review?giftCardId=abcd
      mainUrlSegment = url.substring(0, url.lastIndexOf('?'));
    } else if (url.includes('/campaign-page/')) {
      // This condition is to handle campaign pages
      mainUrlSegment = url.substring(0, url.lastIndexOf('/'));
    } else {
      mainUrlSegment = url;
    }
  }
  return mainUrlSegment as PageUrlSegment;
};

export const getUrlParamId = (url: string, delimeter = '/'): string => {
  const parts: string[] = url.split(delimeter);
  return parts[parts.length - 1];
};
